const isAllCinemas = (resolvedCinemaIds, allCinemaIds) =>
    allCinemaIds.length > 0 && _.difference(allCinemaIds, resolvedCinemaIds).length === 0

export default isAllCinemas
